import { useTranslation } from "react-i18next";
import CustomizedBreadcrumbs from "../../../components/Custom/CustomizedBreadcrumbs";
import { Box, Typography } from "@mui/material";
import CustomizedButton from "../../../components/Custom/CustomizedButton";
import { IBreadcrumbsAndMenu } from "../../../types/global";
import { useNavigate } from "react-router-dom";
import BranchSettingTable from "../../../components/Table/Setting/Branch";

const BranchSetting = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const breadcrumbs: IBreadcrumbsAndMenu[] = [
    {
      name: t("setting.index"),
      to: "/setting",
    },
    {
      name: t("branch.info"),
      to: "/setting/branch",
    },
  ];

  return (
    <>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <Box sx={{ display: "flex", justifyContent: "space-between", my: 3 }}>
        <Typography variant="h5">{t("branch.info")}</Typography>
        <CustomizedButton
          title={t("button.add") + t("branch.index")}
          variant="contained"
          onClick={() => {
            navigate("/setting/branch/add");
          }}
        />
      </Box>
      <BranchSettingTable />
    </>
  );
};

export default BranchSetting;
